//The body of POST integrations/connections/{id}/github/start: mode is a GitHubConnectModes value; returnUrl is where a
//sign-in comes back (this page)
export class GitHubInstallStartRequestDTO {
  mode: number;

  returnUrl: string;

  constructor() {
    this.mode = 0;
    this.returnUrl = '';
  }
}

//The answer of POST integrations/connections/{id}/github/start: where the browser goes to install the GitHub App.
export class GitHubInstallStartDTO {
  url: string;

  constructor() {
    this.url = '';
  }
}

//The body of POST integrations/github/complete: what GitHub put on the way back to Settings > Automation, passed on
//unread. The API trusts none of it until it has verified the state and the installation.
export class GitHubInstallCompleteDTO {
  code: string;

  installationId: number;

  state: string;

  constructor() {
    this.code = '';
    this.installationId = 0;
    this.state = '';
  }
}
